import AlertPopup from 'components/common/PortalModal/popups/AlertPopup';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { functionUtils } from 'utils';

// Reusable inform modal for system failure cases (transport/offline, and opt-in
// HTTP 400/500). Driven entirely by the SET_PORTAL_MODAL payload, so it can be
// triggered from anywhere via helpers/maintenance -> showSystemErrorModal. The
// per-error-type message arrives as `content`. It renders a single Close button:
// AlertPopup shows only its primary (buttonLabel2 / onClick) button full-width
// when buttonLabel1 is absent, so no confirm/secondary button appears here.
const SystemErrorModal = ({
  isShow,
  title,
  content,
  actionClose,
  modalStyles,
  modalData,
}) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();
  const { isDesktop } = useDetectDevice();

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    // Deferred by one microtask so this modal's close lands in a separate
    // React commit from actionClose's store update (e.g. resetStep2ToFirstVisit's
    // step2ResetNonce bump, which remounts <Remittance> via its key in the same
    // commit as actionClose). Closing this modal in the same commit as that
    // remount can make an ungated listener's show-condition true and mount a
    // new PortalModal-hosted Modal in the identical commit as the remount's
    // subtree deletion, racing react-bootstrap's Transition and crashing
    // (browser-smoke#147).
    queueMicrotask(() => closePortalModalName());
  };

  return (
    <AlertPopup
      isOpen={isShow}
      text={t(title) || ''}
      content={t(content) || ''}
      alignContent="center"
      buttonLabel2={t('button_close')}
      onClick={handleOnClose}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
      modalStyles={modalStyles}
      modalData={modalData}
    />
  );
};

export default SystemErrorModal;
